<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="batchRecords"
	[loading]="loading"
	[globalFilterFields]="app.keys(batchRecords)"
	[rowHover]="true"
	[rows]="10"
	[showCurrentPageReport]="true"
	[rowsPerPageOptions]="[10]"
	responsiveLayout="scroll"
	[paginator]="true"
	currentPageReportTemplate="Showing {first} to {last} of {{ totalBatchRecords }} recordName"
	[lazy]="true"
	[totalRecords]="totalBatchRecords"
	(onLazyLoad)="fetchAdditionalRecords($event)"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="businessDate">
				<div class="d-flex w-100">
					Business Date
					<p-sortIcon field="businessDate"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="businessDate" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="number">
				<div class="d-flex w-100">
					Batch ID
					<p-sortIcon field="number"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="number" field="number" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="transactionCount">
				<div class="d-flex w-100">
					Trxn Count
					<p-sortIcon field="transactionCount"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="number" field="transactionCount" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="amount">
				<div class="d-flex w-100">
					Total
					<p-sortIcon field="amount"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="number" field="amount" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="selectRecord(rec.number)">
			<td>
				{{ app.moment(rec.businessDate, 'MMDDYYYY').format('MM/DD/YYYY') }}
			</td>
			<td>{{ rec.number }}</td>
			<td>{{ rec.transactionCount }}</td>
			<td>{{ rec.amount | currency: 'USD':'symbol':'1.2-2' }}</td>
		</tr>
	</ng-template>
</p-table>
